import React, { useEffect, useState } from "react";
import { Box, Dialog, DialogContent, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material"
import { DialogHeader, DialogFooter } from "components/dialog/DialogHeader";
import PaperComponent from "components/PaperComponent";

const InvoiceSearchDialog = ({ title, setDialogOpen, dialogOpen, onFinish }) => {
  const [searchType, setSearchType] = useState("InvNo") // "InvNo" or "BNNo"
  const [searchValue, setSearchValue] = useState("")

  useEffect(() => {
    if (dialogOpen) {
      setSearchType("InvNo")
      setSearchValue("")
    }
  }, [dialogOpen])

  const handleFinish = () => {
    if (!searchValue.trim()) {
      return
    }
    onFinish({ searchType, searchValue: searchValue.trim() })
    setDialogOpen(false)
  }

  const handleSearchTypeChange = (e) => {
    setSearchType(e.target.value)
    setSearchValue("") // Clear search value when changing type
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleFinish()
    }
  }

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xs' >
      <DialogHeader
        handleDialogClose={() => setDialogOpen(false)}
        title={title || "ดึงข้อมูลจากรถร่วม"}
        onDeleteClick={null}
      />
      <DialogContent>
        <Box display='flex' flexDirection='column' gap={2} mt={2}>
          <FormControl component="fieldset">
            <FormLabel component="legend">เลือกประเภทการค้นหา</FormLabel>
            <RadioGroup
              value={searchType}
              onChange={handleSearchTypeChange}
              row
            >
              <FormControlLabel value="InvNo" control={<Radio />} label="เลขที่ใบแจ้งหนี้ (InvNo)" />
              <FormControlLabel value="BNNo" control={<Radio />} label="เลขที่ BN (BNNo)" />
            </RadioGroup>
          </FormControl>

          <Box display="flex" gap={2} justifyContent="center">
            <TextField
              size="small"
              label={searchType === "InvNo" ? "เลขที่ใบแจ้งหนี้" : "เลขที่ BN"}
              value={searchValue}
              onChange={e => setSearchValue(e.target.value)}
              onKeyPress={handleKeyPress}
              fullWidth
              autoFocus
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogFooter
        okText={"ตกลง"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleFinish}
      />
    </Dialog>
  )
}

export default React.memo(InvoiceSearchDialog)